import { Button, Descriptions, Flex, Modal, Input, Switch } from "antd";
import React, { useEffect, useState } from "react";

function DescriptionText({ data, onUpdate }) {
  const [logoOption, setLogoOption] = useState(
    data?.use_custom ? "custom" : "default"
  );
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [customText, setCustomText] = useState(data?.custom_value);
  const [isSaved, setIsSaved] = useState(null);

  const handleLogoChange = (e) => {
    setLogoOption(e);
  };

  const handleEditClick = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOnSave = () => {
    setIsSaved(customText);
    setIsModalVisible(false);
  };

  useEffect(() => {
      setCustomText(isSaved !== null ? isSaved : data?.custom_value);
      setLogoOption(data?.use_custom ? "custom" : "default");
  }, [isModalVisible, data, isSaved]);

  const handleSave = () => {
    let payload = {
      id: data?.id,
      use_custom: logoOption === "custom" ? true : false,
      custom_value: isSaved !== null ? isSaved : data?.custom_value,
    };

    onUpdate(payload);
  };

  const items = [
    {
      key: "1",
      label: "Default Description Text",
      children: data?.default_value,
    },
    {
      key: "2",
      label: (
        <Flex justify="space-between" align="center">
          <p>Custom Description Text</p>
          <Button type="link" onClick={handleEditClick}>
            Edit
          </Button>
        </Flex>
      ),
      children: isSaved !== null ? isSaved : data?.custom_value,
    },
  ];

  const horizontalItem = [
    {
      key: "3",
      label: "Use Custom",
      children: (
        <Switch
          checked={logoOption === "custom"}
          onChange={(checked) =>
            handleLogoChange(checked ? "custom" : "default")
          }
          checkedChildren="Custom"
          unCheckedChildren="Default"
        />
      ),
    },
  ];

  return (
    <div>
      <Descriptions column={2} bordered items={items} layout="vertical" />
      <Descriptions
      className="mt-2"
        column={1}
        bordered
        items={horizontalItem}
        layout="horizontal"
        labelStyle={{ width: "10%" }}
        contentStyle={{ width: "90%" }}
      />
      <Flex className="mt-5" justify="flex-end">
        <Button type="primary" onClick={handleSave}>
          Save
        </Button>
      </Flex>

      {/* Modal for Editing Custom Text */}
      <Modal
        title="Edit Custom Description Text"
        visible={isModalVisible}
        onCancel={handleCancel}
        maskClosable={false}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleOnSave}>
            Save
          </Button>,
        ]}
      >
        <Input.TextArea
          value={customText}
          onChange={(e) => setCustomText(e.target.value)}
          rows={4}
          maxLength={75}
        />
        <small>Characters limit: 75</small>
      </Modal>
    </div>
  );
}

export default DescriptionText;
